"use client";

// src/feedback-text.tsx
import * as React from "react";
import {
  mergeStyles,
  systemForwardRef,
  useStyleConfig
} from "@stepstone-genesis/system";
import { Text } from "@stepstone-genesis/components-text";
import {
  useFormStateHandlerContext,
  useFormStateHandler
} from "@stepstone-genesis/components-form-state-handler";

// src/styles.ts
import { styles as textStyles } from "@stepstone-genesis/components-text";
var root = {
  color: "colorStatusNegativeDefault"
};
var variants = {
  negative: {
    color: "colorStatusNegativeDefault"
  },
  positive: {
    color: "colorStatusPositiveDefault"
  }
};
var sizes = {
  medium: textStyles.variants.small,
  large: textStyles.variants.medium
};
var styles = {
  root,
  variants,
  sizes
};

// src/feedback-text.tsx
var FormFeedbackElement = systemForwardRef(
  function FormFeedbackElement2({
    context,
    children,
    textProps,
    variant = "negative",
    size = "medium",
    sx,
    ...props
  }, ref) {
    const { FORM_FEEDBACK_TEXT } = useStyleConfig("FORM_FEEDBACK_TEXT", {
      styles: {
        base: styles.root,
        variants: styles.variants,
        responsiveVariants: [
          {
            id: "feedback-text-size",
            prop: size,
            variants: styles.sizes
          }
        ]
      },
      props: {
        variant
      }
    });
    if (!(context == null ? void 0 : context.isInvalid) && variant !== "positive" || !(context == null ? void 0 : context.isValid) && variant !== "negative")
      return null;
    return /* @__PURE__ */ React.createElement(
      Text,
      {
        as: "div",
        element: "FORM_FEEDBACK_TEXT",
        sx: mergeStyles([FORM_FEEDBACK_TEXT.styles, sx]),
        ...textProps,
        ...props,
        ...context == null ? void 0 : context.formFeedbackTextProps(props, ref)
      },
      children
    );
  }
);
var FormFeedbackElementNonContext = systemForwardRef(function FormFeedbackElementNonContext2(props, ref) {
  const nonContextFormStateHandler = useFormStateHandler(props);
  return /* @__PURE__ */ React.createElement(
    FormFeedbackElement,
    {
      context: nonContextFormStateHandler,
      ref,
      ...props
    }
  );
});
var FormFeedbackText = systemForwardRef(
  function FormFeedbackText2(props, ref) {
    const withinContextFormStateHandler = useFormStateHandlerContext();
    return withinContextFormStateHandler ? /* @__PURE__ */ React.createElement(
      FormFeedbackElement,
      {
        context: withinContextFormStateHandler,
        size: withinContextFormStateHandler.size,
        ref,
        ...props
      }
    ) : /* @__PURE__ */ React.createElement(FormFeedbackElementNonContext, { ref, ...props });
  }
);
export {
  FormFeedbackText
};
